import { useQuery } from "@tanstack/react-query";
import { getBasePayload } from "routes/analysis/queries/analysis";
import { ListType, UserListData } from "routes/analysis/types/analysis";
import { getData } from "services/api-actions";
import { GeneralFilter } from "types/common";

export const FetchUserList = (analysisId?: string, type?: ListType, id?: string, filter?: GeneralFilter, search?: string) => useQuery({
  queryKey: ["userList", analysisId, type, id, filter, search],
  queryFn: () => getUserList(analysisId, type, id, filter, search),
  staleTime: 1000 * 60 * 5
});

export const SearchUsers = (analysisId?: string, search?: string) => useQuery({
  queryKey: ["searchUsers", analysisId, search],
  queryFn: () => getUserList(analysisId, ListType.All, undefined, { tests: [ 1, 2, 4, 8 ] }, search),
  staleTime: 1000 * 60 * 5,
  enabled: search !== undefined && search.length > 2
});

export const getUserList = async (analysisId?: string, type?: ListType, id?: string, filter?: GeneralFilter, search?: string) => {
  if (!analysisId) throw new Error("No analysis id provided");
  if (!filter) throw new Error("No filter provided");
  const payload = getBasePayload(filter, { listType: type, id: id, s: search });
  const data = await getData<UserListData>(`analysis/${analysisId}/users?${payload}`);
  if (!data.result) throw new Error("No data found");
  return data.result;
}